<div class="snackBar root-snackbar-error root-snackbar">
  <div class="svg-container">
    <svg width="91" height="85" viewBox="0 0 91 85" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="86" height="85">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6.10352e-05H85.487V85H0V6.10352e-05Z" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M72.153 21.9385C80.3947 33.2635 86.7983 45.1814 85.2567 56.625C83.7151 68.0686 74.2875 79.0971 63.1403 83.129C51.9933 87.161 39.186 84.1963 26.7937 78.8007C14.4607 73.4049 2.60205 65.5783 0.408208 55.6171C-1.84496 45.6558 5.56675 33.5007 14.3421 22.1164C23.1175 10.6728 33.316 6.10352e-05 43.455 6.10352e-05C53.6535 6.10352e-05 63.8519 10.6727 72.153 21.9385Z"
          fill="#193356" />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M66.0046 45.2462C66.0046 56.14 57.1734 64.9713 46.2795 64.9713C35.3856 64.9713 26.5544 56.14 26.5544 45.2462C26.5544 34.3523 35.3856 25.5211 46.2795 25.5211C57.1734 25.5211 66.0046 34.3523 66.0046 45.2462Z"
        fill="#FCCC04" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M64.4204 43.6618C64.4204 54.5557 55.5891 63.3869 44.6953 63.3869C33.8014 63.3869 24.9702 54.5557 24.9702 43.6618C24.9702 32.768 33.8014 23.9368 44.6953 23.9368C55.5891 23.9368 64.4204 32.768 64.4204 43.6618Z"
        fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M54.5926 36.2852L52.0719 33.7645L44.6952 41.1411L37.3185 33.7645L34.7979 36.2852L42.1746 43.6618L34.7979 51.0384L37.3185 53.5592L44.6952 46.1825L52.0719 53.5592L54.5926 51.0384L47.2159 43.6618L54.5926 36.2852Z"
        fill="#193356" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.59618 20.0791L7.756 19.2389L5.32427 21.6705L2.89255 19.2389L2.05237 20.0791L4.48402 22.5108L2.05237 24.9425L2.89255 25.7828L5.32427 23.3511L7.756 25.7828L8.59618 24.9425L6.16453 22.5108L8.59618 20.0791Z"
        fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M90.3484 29.8229L89.5082 28.9826L87.0765 31.4143L84.6447 28.9826L83.8046 29.8229L86.2362 32.2545L83.8046 34.6862L84.6447 35.5265L87.0765 33.0948L89.5082 35.5265L90.3484 34.6862L87.9167 32.2545L90.3484 29.8229Z"
        fill="#193356" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.1157 70.8879L28.5324 69.3332L30.0872 67.75L29.5401 67.2127L27.9854 68.7959L26.4021 67.2412L25.8649 67.7883L27.4482 69.343L25.8934 70.9262L26.4405 71.4635L27.9952 69.8802L29.5785 71.435L30.1157 70.8879Z"
        fill="white" />
    </svg>
  </div>
  <div class="text-container">
    <div class="title">Oups.</div>
    <div class="message">
      {{ data.message }}
    </div>
    <button mat-icon-button class="close-icon" *ngIf="displayCloseBtn" (click)="close()">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
</div>
